import { Guardian } from '@xaamin/guardian';

Guardian.define('emisor.crear', (user) => {
  return user.can('emisor.crear');
});

Guardian.define('emisor.listar', (user) => {
  return user.can('emisor.listar');
});

Guardian.define('emisor.info', (user) => {
  return user.can('emisor.info');
});

Guardian.define('emisor.personalizar', (user) => {
  return user.can('emisor.personalizar');
});

Guardian.define('emisor.actualizar.csd', (user) => {
  return user.can('emisor.actualizar.csd');
});

Guardian.define('emisor.editar', (user) => {
  return user.can('emisor.editar');
});

Guardian.define('emisor.bloquear', (user) => {
  return user.can('emisor.bloquear');
});

Guardian.define('emisor.manifiesto', (user) => {
  return user.can('emisor.manifiesto');
});

Guardian.define('emisor.descargar', (user) => {
  return user.can('emisor.descargar');
});